// ThreeEvaluationCards.tsx

import React, { useEffect } from 'react';
import { Card, CardContent, CardHeader, IconButton, Tooltip, Box, Typography } from '@material-ui/core';
import { Panel } from '../../../../../Components/Panel/Panel';
import { useIntl } from 'react-intl';
import { Form, HtmlView, Loading } from '../../../../../Components';
import { useFormField } from '../../../../../Components/Form/FormField';
import { Edit } from '@material-ui/icons';
import { useStyles } from './List.styles';
import { useEvaluationCardState } from './evalutionState';

// editMode alag component mein nikalo taaki mount/unmount ho
const ThreeEvaluationCards = () => {
  const { formatMessage } = useIntl();
  const classes = useStyles();
  const { data, editingData, loading, editMode, submit, startEdit, cancelEdit } = useEvaluationCardState();
  useEffect(() => {
    if (!loading && !data) {
      startEdit();
    }
  }, [loading, data, startEdit]);
  return (
    <Panel titleKey="admin.law-portal.subMenu.settings.threeevealutioncard" accordion>
      {loading ? (
        <Loading />
      ) : editMode ? (
        // ✅ key={editingData} — jab editingData set ho tab fresh mount hoga
        <EvaluationForm
          key={editingData ?? 'empty'}
          editingData={editingData}
          submit={(form, api, onSuccess) => submit(form, api, onSuccess, formatMessage)}
          cancelEdit={cancelEdit}
        />
      ) : (
        <Card variant="outlined" className={classes.root}>
          <CardHeader
            action={
              <Tooltip title={formatMessage({ id: 'utils.icon.edit', defaultMessage: 'Edit' })}>
                <IconButton
                  aria-label={formatMessage({ id: 'utils.icon.edit', defaultMessage: 'Edit' })}
                  onClick={startEdit}
                >
                  <Edit fontSize="small" />
                </IconButton>
              </Tooltip>
            }
          />
          <CardContent>
            <Box>
              {data?.evaluationInformationSv && (
                <Box style={{ marginBottom: '25px' }}>
                 <Typography variant="h6" style={{ marginBottom: '7px' }}>
                    {formatMessage({
                      id: 'admin.law-portal.informationBoard.form.message.label.sv',
                      defaultMessage: 'Message (Swedish)',
                    })}
                  </Typography>
                  <HtmlView value={data.evaluationInformationSv} />
                </Box>
              )}
              {data?.evaluationInformationEn && (
                <Box style={{ marginBottom: '20px' }}>
 <Typography variant="h6" style={{ marginBottom: '7px' }}>
                    {formatMessage({
                      id: 'admin.law-portal.informationBoard.form.message.label.en',
                      defaultMessage: 'Message (English)',
                    })}
                  </Typography>
                  <HtmlView value={data.evaluationInformationEn} />
                </Box>
              )}
            </Box>
          </CardContent>
        </Card>
      )}
    </Panel>
  );
};

const EvaluationForm = ({
  editingData,
  submit,
  cancelEdit,
}: {
  editingData: any;
  submit: any;
  cancelEdit: () => void;
}) => {
  const { formatMessage } = useIntl();

  const chapterSv = useFormField({
    label: formatMessage({
      id: 'admin.law-portal.informationBoard.form.message.label.sv',
      defaultMessage: 'Message (Swedish)',
    }),
    name: 'EvaluationInformationSv',
    type: 'rich-text',
    required: false,
    richTextEditorHeight: 'small',
    initialState: editingData?.evaluationInformationSv
      ? { value: editingData.evaluationInformationSv, label: editingData.evaluationInformationSv, isValid: true }
      : undefined,
  });

  const chapterEn = useFormField({
    label: formatMessage({
      id: 'admin.law-portal.informationBoard.form.message.label.en',
      defaultMessage: 'Message (English)',
    }),
    name: 'EvaluationInformationEn',
    type: 'rich-text',
    required: false,
    richTextEditorHeight: 'small',
    initialState: editingData?.evaluationInformationEn
      ? { value: editingData.evaluationInformationEn, label: editingData.evaluationInformationEn, isValid: true }
      : undefined,
  });

  return (
    <Form
      submit={submit}
      cancel={cancelEdit}
      groups={[{ grid: { type: 'column', items: [chapterSv, chapterEn] } }]}
    />
  );
};

export default ThreeEvaluationCards;